<template>
    <b-container>
        <button-row :Buttons="Buttons"></button-row>
        <div v-for="(agenda, agenda_i) in event.event_agenda" :key="agenda_i" class="mt-3">
            <event-core-info :event="event" :agenda="agenda" :detailView="false" :hideAgendaIntro="true"></event-core-info>
            <b-btn v-if="userListExpandable && !isActivity" @click="toggleUserList(agenda_i)" style="font-size: 18px;" variant="link border-0" class="btn-block pt-2 px-0 d-flex align-items-center justify-content-between"><strong>Teilnehmerliste anzeigen</strong><svg-icon-double-arrow-down></svg-icon-double-arrow-down></b-btn>
            <b-collapse :id="`user-list-${agenda_i}`" :visible="event.event_agenda.length == 1 || isActivity">
                <user-list :agenda="agenda" class="mb-4" :expandable="userListExpandable && !isActivity"></user-list>
            </b-collapse>
            <b-row class="border-bottom border-primary" v-if="agenda_i < event.event_agenda.length - 1"></b-row>
        </div>
        
    </b-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ButtonRowVue from '../components/ButtonRow.vue'
import EventCoreInfoVue from '../components/EventCoreInfo.vue'
import UserListVue from '../components/Event-User-List.vue';
import SvgIconDoubleArrowDown from '@/components/svg-icon/DoubleArrowDown.vue';
export default {
    name: 'event-presence-cmp',
    components: {
        'button-row': ButtonRowVue,
        'event-core-info': EventCoreInfoVue,
        'user-list': UserListVue,
        'svg-icon-double-arrow-down': SvgIconDoubleArrowDown
    },
    props: {
    },
    mounted() {
        this.init();
    },
    computed: {
        ...mapGetters('auth', ['loggedIn', 'isActivity']),
        ...mapGetters('events', ['fetching', 'event']),
        
        Buttons() {
            return [
                {
                    title: 'Terminübersicht',
                    to: '/event-list',
                    variant: 'light border',
                    icons: {
                        left: {
                            icon: ['far', 'arrow-left'],
                            visible: true
                        },
                        right: {
                            icon: ['far', 'arrow-right'],
                            visible: false
                        }
                    }
                }
            ]
        },
        userListExpandable() {
            return this.event.event_agenda.length > 1;
        }
    },
    methods: {
        ...mapActions('events', ['fetchEvent']),
        init() {
            this.fetchEvent(this.$route.params.Id);
            this.addEventListener();
        },
        addEventListener() {
            // Event.$emit('saveApplicationSuccess', event);
            window.LC_Event.$on('saveApplicationSuccess', () => {
                this.fetchEvent(this.$route.params.Id);
            })
            window.LC_Event.$on('updateApplicationStatusSuccess', () => {
                this.fetchEvent(this.$route.params.Id);
            })
        },
        toggleUserList(agenda_index) {
            this.$root.$emit('bv::toggle::collapse', `user-list-${agenda_index}`);
        }
    }
}
</script>

<style lang="scss">
    @import '../scss/variables';
@import 'bootstrap/scss/bootstrap.scss';
.border-bottom {
    border-bottom-width: 2px !important
}
</style>